export default __webpack_public_path__ + "static/media/bodegabarriles.9fe96936.jpg";